

















import Vue from 'vue';
import axios from 'axios';

export type Subject = {
  name: string
  subject_id: number
}


export default Vue.extend({
  props: {
    text: {
      type: Object,
      required: true
    },
    icons: {
      type: Object,
      required: true
    },
    subjects: {
      type: Array as () => Subject[],
    }
  },
  computed: {
    year() {
      return this.$store.state.year
    },
    month() {
      return this.$store.state.month
    },
    isControlledPdf() {
      const userAgent = window.navigator.userAgent.toLowerCase()

      // Microsoft Edgではfalseを返す
      if (userAgent.indexOf('edg') != -1) return false

      if (
        // Internet Explorer 10以下用
        userAgent.indexOf('msie') != -1 ||
        // Internet Explorer用
        userAgent.indexOf('trident') != -1 ||
        // Google Chrome用（iOSは除く）
        (userAgent.indexOf('chrome') != -1 &&
          !(
            userAgent.indexOf('iphone') != -1 ||
            userAgent.indexOf('ipad') != -1 ||
            userAgent.indexOf('android') != -1
          ))
      ) {
        return true
      }
      return false
    },
    domainS3Path() {
      return process.env.VUE_APP_DOMAIN_S3_PATH
    },
  },
  methods: {
    async getPdf(key: string, filename: string) {
      try {
        const month = ('0' + this.month).slice(-2)
        const res = await axios.post('/api/v1/aws/get_pdf/', { key: `${this.year}${month}/${key}/${filename}.pdf`}, { responseType: 'blob', dataType: 'binary' })
        const blob = new Blob([res.data], { type: res.data.type })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        if (this.isControlledPdf) link.setAttribute('target', '_blank');
        link.click()
      } catch (e) {
        return { status: 'error', message: e }
      }
    },
    subjectIcon(iconSubmectId: number) {
      const iconSubject = this.subjects.find(
        (subject: Subject) => subject.subject_id === iconSubmectId
      )
      return iconSubject ? this.icons[iconSubject.name] : this.icons['表紙']
    }
  }
});
